<template>
  <div :class="isCovertMode ? 'container2' : 'container'">
    <van-nav-bar
      id='van-nav-bar'
      title="星店"
      right-text="设置"
      fixed
      @click-right="onClickRight"
    />
    <van-pull-refresh head-height v-model="isLoading" @refresh="onRefresh">
      <div class="pull-container">
        <div class="data-wrapper">
          <div v-if="!isCovertMode" class="title" @click="clicked1">
            ———— {{ time }}({{ day }})销售金额 ————
          </div>
          <div class="finance">
            <span @click="clicked1">￥{{ todayAmount }}</span>
            <span class="order-count" @click="clicked1">({{todayCount}}单)</span>
          </div>
          <div class="data-group">
            <div class="order data-item" @click="clicked1">
              <div class="count">{{ todayCount }}</div>
              <div class="name">订单数量</div>
            </div>
            <div class="group data-item" @click="clicked2">
              <div class="count">{{ totalMember }}</div>
              <div class="name">团队数量</div>
            </div>
            <div class="balance data-item" @click="clicked3">
              <div class="count">{{ remainAmount }}</div>
              <div class="name">账号余额</div>
            </div>
          </div>
        </div>
        <div class="chart-box">
          <div
          id="myChart"
        ></div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import Vue from "vue";
import Vuex from "vuex";
import { app } from "../../utils/app";
import { indexData } from "../../utils/api";
import { NavBar, PullRefresh } from "vant";

Vue.use(PullRefresh);
Vue.use(NavBar);
Vue.use(Vuex);

// @ is an alias to /src102.42

export default {
  name: "ShopData",
  components: {},
  data() {
    return {
      isCovertMode: this.$isCovertMode,
      saleList: "",
      todayAmount: "",
      todayCount: "",
      totalCount: "",
      totalMember: "",
      remainAmount: "",
      series: {
        name: "销量",
        type: "bar",
        label: {
            show: true,
            position: 'top',
            color: '#666666',
            fontSize: '12px',
            fontWeight: 'bold',
            // formatter:function(data) {
            //   if (data.data > 10000) {
            //     return `${Math.floor(data.data/10000)}万`;
            //   } else if(data.data == 10000){
            //     return '1万';
            //   } else {
            //     return data.data
            //   }
            // }
        },
        data: [],
      },
      xAxis: {
        data: [],
      },
      yAxis: [{
        type: "value",
        show: true,
        axisLabel: {
          formatter:function(value) {
            if (value > 10000) {
              return `${Math.floor(value/10000)}万`;
            } else if(value == 10000){
              return '1万';
            } else {
              return value
            }
          },
          color:'#666666'
        }
      }],
      time: "",
      day: "",
      count: 0,
      isLoading: false
    };
  },
  created() {
    console.log("isCovertMode:", this.$isCovertMode);
    this.indexData();
    let times = this.getTime();
    this.time = times;
    console.log(times);
  },
  mounted() {
    console.log("mounted");
  },
  watch: {},
  methods: {
    async indexData() {
      let shopToken =
        this.$store.state.shopToken || app.storage.get("shopToken");
      if (shopToken) {
        console.log(shopToken);
        let res = await indexData({
          usertoken: shopToken,
        });
        this.saleList = res.data.saleList;
        this.todayAmount = res.data.todayAmount;
        this.todayCount = res.data.todayCount;
        this.totalCount = res.data.totalCount;
        this.totalMember = res.data.totalMember;
        this.remainAmount = res.data.remainAmount;

        let seriesData = [];
        let xAxisData = [];
        res.data.saleList.forEach((res) => {
          seriesData.push(Math.floor(res.amount));
          xAxisData.push(res.displayDay);
        });
        this.series.data = seriesData;
        this.xAxis.data = xAxisData;
        // this.myEcharts();
        this.day = this.getDay();
        this.myEcharts()
      } else {
        this.$router.push({
          path: "/ShopLogin",
        });
      }
    },
    clicked1() {
      // console.log(this.$store.state.token)
      this.$router.push({
        path: "/ShopOrderList",
      });
    },
    clicked2() {
      // console.log(this.$store.state.userInfo)
      this.$router.push({
        path: "/ShopFriends",
      });
    },
    clicked3() {
      // console.log(this.$store.state.shopInfo)
      this.$router.push({
        path: "/ShopFinance",
      });
    },
    clicked4() {
      // console.log(this.$store.state.userInfo)
      this.$router.push({
        path: "/ShopSet",
      });
    },
    onClickRight() {
      this.$router.push({
        path: "/ShopSet",
      });
    },
    myEcharts() {
      if (!document.getElementById("myChart")) {
        return
      }
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById("myChart"));

      // 指定图表的配置项和数据
      var option = {
        title: {
          text: "近一周销量",
          textStyle:{
            color:'#aaaaaa'
          }
        },
        color:'#FFB103',
        tooltip: {},
        legend: {
          data: ["销量"],
          textStyle:{
            color:'#dedede'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: this.xAxis,
        yAxis: this.yAxis,
        series: [this.series],
        textStyle:{
          color:'#333333',
          fontSize:18,
          fontWeight:'Bold'
        }
      };
      console.log("option", option);
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    getTime() {
      var date = new Date();
      var Y = date.getFullYear() + "/";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "/";
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return Y + M + D;
    },
    getDay() {
      let dayNo = new Date().getDay();
      let res;
      switch (dayNo) {
        case 1:
          res = "星期一";
          break;
        case 2:
          res = "星期二";
          break;
        case 3:
          res = "星期三";
          break;
        case 4:
          res = "星期四";
          break;
        case 5:
          res = "星期五";
          break;
        case 6:
          res = "星期六";
          break;
        case 7:
          res = "星期日";
          break;
        default:
          break;
      }
      return res;
    },
    onRefresh() {
      this.indexData();
      setTimeout(() => {
        console.log("刷新成功");
        this.isLoading = false;
        this.count++;
      }, 1000);
    }
  },
};
</script>
<style lang="scss">
$white: #ffffff;
$red1: #ff3366;
$black: #000000;
.pull-container{
.data-wrapper{
  color: $black;
  text-align: center;
  padding-top: 20px;
  .finance{
    color: #f74c31;
    font-size: 2rem;
    font-weight: bold;
    height: 2rem;
    line-height: 2rem;
    margin-top: 10px;
    .order-count{
      font-size: 1.5rem;
    }
  }
  button {
    width: 12.5rem;
    height: 3.125rem;
    margin: 0.625rem;
  }
  .title{
    color: #aaaaaa;
    font-size: 0.8rem;
    font-weight: 600;
  }
}
}

.data-group {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  margin-top: 1rem;
	.data-item{
		min-width: 32%;
		text-align: center;
		height: 3.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    box-shadow: -1px -1px 4px #d3d3d3;
    .count{
      height: 1rem;
      color: #f74c31;
      font-size: 1rem;
      font-weight: bold;
    }
    .name{
      height: 1rem;
      margin-top: 6px;
      color: #333333;
    }
	}
}

#app {
  min-height: 100vh;
}
.container2 {
  padding-top: 46px;
}
.ad {
  min-height: 300px;
}
.pull-container {
  min-height: calc(100vh - 46px);
  margin-top: 46px;
  .chart-box{
    padding: 10px;
    #myChart{
      width: 100%;
      height: 300px;
      margin: 20px 0;
      // padding: 10px;
      box-sizing: border-box;
      // box-shadow: -2px -1px 4px #ededed;
      // border-radius: 4px;
    }
  }
}
</style>
